export default class Util {
  constructor() {}

  formatDate(date) {
    if (!date) return null;

    const [year, month, day] = date.split("-");

    if (!year || !month || !day) return date;

    var dataFormatada = `${day}/${month}/${year}`;

    return dataFormatada;
  }
  parseDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split("/");

    if (!year || !month || !day) return date;

    var dataParseada = `${year}-${month.padStart(2, "0")}-${day.padStart(
      2,
      "0"
    )}`;

    return dataParseada;
  }
  parseDateSemTracos(date) {
    if (!date) return null;

    const [day, month, year] = date.split("/");

    if (!year || !month || !day) return date;

    var dataParseada = `${year}${month.padStart(2, "0")}${day.padStart(
      2,
      "0"
    )}`;

    return dataParseada;
  }
  normalizeString(str) {
    return str
      ? str.normalize("NFD").replace(/[\u0300-\u036f]|[^0-9 a-zA-Z]/g, "")
      : "";
  }
  compare(key) {
    return function(a, b) {
      const genreA = a[key].toUpperCase();
      const genreB = b[key].toUpperCase();

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    };
  }
}
